import React, { Fragment } from 'react';
// import { Link } from 'gatsby';
import Image from 'reusecore/src/elements/Image';
import Container from '../../../components/UI/Container';

import FeaturedProductsWrapper, {
  GridContainer,
  ProductItemWrapper,
  SingleProductWrapper
} from './featured.style';

const products = [
  {
    excerpt:
      'AirZing UV-C es una tecnología probada en destruir microorganismos de manera eficiente.',
    frontmatter: {
      href: 'https://www.medlight.cl/productos/airzing-uvc',
      thumbnail:
        'https://res.cloudinary.com/chamlabs/image/upload/f_auto,q_auto/v1587778024/medlight-cl/air-zing-medlight_jhgiib.png',
      title: 'AirZing UVC',
      tags: ['UV-C', 'luminaria', 'solucion']
    }
  },
  {
    excerpt: 'Tubos Germicidas HNS OSRAM | PURITEC HNS UV-C',
    frontmatter: {
      href: 'https://www.medlight.cl/productos/hns-osram-uvc',
      thumbnail:
        'https://res.cloudinary.com/chamlabs/image/upload/f_auto,q_auto/v1593370192/medlight-cl/products/hns-g5/puritec-hns-8w-g5_qzvgje.jpg',
      title: 'Tubos Germicidas HNS OSRAM UV-C',
      tags: ['UV-C', 'purificación']
    }
  },
  {
    excerpt: 'Unidad Móvil UV-C HSN 36Wx6 OSRAM | PURITEC HNS UV-C',
    frontmatter: {
      href: 'https://www.medlight.cl/productos/unidad-movil-uvc',
      thumbnail:
        'https://res.cloudinary.com/chamlabs/image/upload/f_auto,q_auto/v1594164266/medlight-cl/products/UVM216-Product-info_mdfyl7.png',
      title: 'Unidad Móvil UV-C',
      tags: ['UV-C', 'luminaria', 'solucion']
    }
  }
];

const FeaturedProducts = ({ heading }) => {
  // if (featured.length < 1) {
  //   return null;
  // }
  // const products = featured.map(edge => edge.node);
  return (
    <FeaturedProductsWrapper>
      <Container>
        <GridContainer template='auto'>
          <div className='inner-heading'>
            <h2>{heading}</h2>
            {/* <p>{subtitle}</p> */}
          </div>
        </GridContainer>
        {products.length === 1 && (
          <GridContainer template='auto'>
            {products.map(product => {
              const {
                excerpt,
                frontmatter: { href, thumbnail, title, tags = [] }
              } = product;
              return (
                <SingleProductWrapper key={`sp-product-${title}`}>
                  <div className='product-img'>
                    <a href={href} target='_blank' rel='noopener noreferrer'>
                      <Image src={thumbnail} alt={`${title} from Medlight`} />
                    </a>
                  </div>
                  <div className='product-info-group'>
                    <div className='product-tags'>
                      {tags.map((tag, index) => {
                        const isLast = index === tags.length - 1;
                        return (
                          <Fragment key={`${title}-${tag}`}>
                            <span>{tag}</span>
                            {!isLast && <span className='divider'>|</span>}
                          </Fragment>
                        );
                      })}
                    </div>
                    <div className='product-info'>
                      <a href={href} target='_blank' rel='noopener noreferrer'>
                        <h3>{title}</h3>
                        <p>{excerpt}</p>
                      </a>
                    </div>
                  </div>
                </SingleProductWrapper>
              );
            })}
          </GridContainer>
        )}
        {products.length > 1 && (
          <GridContainer template='1fr'>
            {products.map(product => {
              const {
                excerpt,
                frontmatter: { href, thumbnail, title, tags = [] }
              } = product;
              return (
                <ProductItemWrapper key={`sp-product-${title}`}>
                  <div className='product-img'>
                    <a href={href} target='_blank' rel='noopener noreferrer'>
                      <Image src={thumbnail} alt={`${title} from MedLight`} />
                    </a>
                  </div>
                  <div className='product-info-group'>
                    <div className='product-tags'>
                      {tags.map((tag, index) => {
                        const isLast = index === tags.length - 1;
                        return (
                          <Fragment key={`${title}-${tag}`}>
                            <span>{tag}</span>
                            {!isLast && <span className='divider'>|</span>}
                          </Fragment>
                        );
                      })}
                    </div>
                    <div className='product-info'>
                      <a href={href} target='_blank' rel='noopener noreferrer'>
                        <h3>{title}</h3>
                        <p>{excerpt}</p>
                      </a>
                    </div>
                  </div>
                </ProductItemWrapper>
              );
            })}
          </GridContainer>
        )}
      </Container>
    </FeaturedProductsWrapper>
  );
};

export default FeaturedProducts;
